<div>
    <app-form [formGroup]="form">
        <app-form-field-row label="ANNEX.UNDERWRITER_COMMENT" valueSize="12">
            <app-textarea formControlName="uwrComment" [maxlength]="4000"></app-textarea>
        </app-form-field-row>
    </app-form>
</div>
